import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { OrderIndData } from "../types";
import { loadOrderInd } from "../thunks/loadOrderInd";

export const useDisplayOrderInd = (orderid?: number) => {
  const storeOrderInd = useSelector<StoreType, OrderIndData | undefined>(
    (store) => store.data.trading.orderind.displayedOrderInd
  );

  const displayedORderInd =
  storeOrderInd && storeOrderInd.orderIndId === orderid ? storeOrderInd : undefined;

  const displatch = useDispatch();

  React.useEffect(() => {
    if (orderid) {
      displatch(loadOrderInd(orderid));
    }
  }, [displatch, orderid]);

  return displayedORderInd;
};
